import type { ReactNode } from 'react'

/**
 * The table is waiting on somebody else. Shown wherever a phone has nothing to
 * do, because a static line of text is indistinguishable from a frozen app -
 * people put the phone down and stop watching. The pulse says the game is
 * still running and it is not their move.
 */
export function WaitingOn({
  who,
  children,
  testId,
}: {
  /** The player being waited on, when it is one person. */
  who?: string
  children: ReactNode
  testId?: string
}) {
  return (
    <div className="waitfor" data-testid={testId ?? 'waiting-on'}>
      <span className="waitfor__pulse" aria-hidden="true">
        <span className="waitfor__ring" />
        <span className="waitfor__ring" />
        <span className="waitfor__core">{who ? who.slice(0, 1).toUpperCase() : '…'}</span>
      </span>
      <p className="waitfor__text">
        {children}
        <span className="waitfor__dots" aria-hidden="true">
          <i />
          <i />
          <i />
        </span>
      </p>
    </div>
  )
}
